import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'

type RecentConversationUser = {
  id: number
  uuid: string
  name: string
  email: string
  phone_number: string
  last_conversation_at: string
}

type Data = {
  data: RecentConversationUser[]
}

const fetchOrganizationRecentConversations = async (organizationId: string) => {
  let response = await fetch(
    `${BASE_API_URL}/admin/api/v2/users/users_by_recent_conversations/${organizationId}`,
    {
      method: API_METHODS.GET,
      headers: apiHeaders(store.getState()),
    }
  )
  response = handleErrors(response)
  const json: Data = await response.json()
  return json
}

export const useOrganizationRecentConversations = (organizationId: string) => {
  return useQuery(
    ['organization-recent-conversations', organizationId],
    () => fetchOrganizationRecentConversations(organizationId),
    {
      enabled: !!organizationId,
    }
  )
}
